import React from "react";
import "./App.css";
import "./index.css";

import { Route, Routes } from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Home from "./components/home/Home";
import About_us from "./components/about-us/About_us";
import Contact_us from "./components/contact-us/Contact_us";
import Privacy_policy from "./components/privacy-policy/Privacy_policy";
import Terms_Conditions from "./components/terms_conditions/Terms_Conditions";
import Become_Seller from "./components/become_seller/Become_Seller";
import Refund_Policy from "./components/refund-policy/Refund_Policy";

function App() {
  return (
    <>
      {/* <ScrollToTop /> */}
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About_us />} />
        <Route path="/contact-us" element={<Contact_us />} />
        <Route path="/privacy-policy" element={<Privacy_policy />} />
        <Route path="/terms-condition" element={<Terms_Conditions />} />
        <Route path="/become-seller" element={<Become_Seller />} />
        <Route path="/refund-policy" element={<Refund_Policy />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
